const FileIcon = ({ className, fill = '#41479B' }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="-5.0 -10.0 110.0 135.0"
    width="32"
    height="32"
  >
    <path
      d="m39.145 82.812c-7.8008 0-14.145-6.3438-14.145-14.145v-48.219c-5.2969 0.79688-9.375 5.3633-9.375 10.879v48.359c0 6.8906 5.6094 12.5 12.5 12.5h32.734c5.5156 0 10.082-4.0781 10.879-9.375z"
      fill={fill}
    />
    <path
      d="m65.625 29.688c-1.7266 0-3.125-1.3984-3.125-3.125v-18.75h-23.355c-6.0781 0-11.02 4.9453-11.02 11.02v49.836c0 6.0781 4.9453 11.02 11.02 11.02h34.211c6.0781 0 11.02-4.9453 11.02-11.02v-38.98zm-2.4297 37.5h-19.445c-1.7266 0-3.125-1.3984-3.125-3.125s1.3984-3.125 3.125-3.125h19.445c1.7266 0 3.125 1.3984 3.125 3.125s-1.3984 3.125-3.125 3.125zm5.5547-12.5h-25c-1.7266 0-3.125-1.3984-3.125-3.125s1.3984-3.125 3.125-3.125h25c1.7266 0 3.125 1.3984 3.125 3.125s-1.3984 3.125-3.125 3.125zm0-12.5h-25c-1.7266 0-3.125-1.3984-3.125-3.125s1.3984-3.125 3.125-3.125h25c1.7266 0 3.125 1.3984 3.125 3.125s-1.3984 3.125-3.125 3.125z"
      fill={fill}
    />
    <path d="m68.75 9.8047v13.633h13.668z" fill={fill} />
  </svg>
);

export default FileIcon;
